export enum SecuringReason {
  BITE_INCIDENT = 'bite_incident',
  OWNER_DEATH = 'owner_death',
  OWNER_ACCIDENT_HOSPITAL = 'owner_accident_hospital',
  OWNER_CUSTODY = 'owner_custody',
  DANGER_PREVENTION = 'danger_prevention',
  ANIMAL_WELFARE = 'animal_welfare',
  OTHER = 'other',
}
